import { render, staticRenderFns } from "./CargarAspectoCompuesta.vue?vue&type=template&id=c27f3818"
import script from "./CargarAspectoCompuesta.vue?vue&type=script&lang=js"
export * from "./CargarAspectoCompuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c27f3818')) {
      api.createRecord('c27f3818', component.options)
    } else {
      api.reload('c27f3818', component.options)
    }
    module.hot.accept("./CargarAspectoCompuesta.vue?vue&type=template&id=c27f3818", function () {
      api.rerender('c27f3818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/acciones/CargarAspectoCompuesta.vue"
export default component.exports